import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
// Renderizado dentro de Layout global vÃ­a AppRoutes; no incluir Layout/CintaOpciones aquÃ­
import ListaUnificada from '../components/common/ListaUnificada.jsx';
import { FormularioBase } from '../components/formularios/index.js';
import Modal from '../components/common/Modal';
import FiltroSucursal from '../components/common/FiltroSucursal';
import equiposService from '../services/equiposService.js';
import { useConfirm } from '../components/common/ModalConfirmacion';

const HELP = {
  prereqs: [
    'Tener cargados los tipos de equipo, las familias, las marcas y modelos, y los tipos de contador.',
  ],
  tips: [
    'El número interno identifica al equipo en todo el sistema: conviene que coincida con el que usa la gente en obra.',
    'El tipo de contador define si el equipo se controla por horas o por kilómetros, y de eso dependen sus mantenimientos.',
    'Asignar obra, centro de costo y empresa es lo que permite después filtrar y comparar en los informes.',
    'Desde la ficha de cada equipo se accede a su historial completo: mantenimientos, reparaciones, consumos y documentación.',
  ],
  nextSteps: [
    'Asignar el plan de mantenimiento que corresponda a cada equipo.',
    'Cargar la documentación del equipo con sus fechas de vencimiento.',
  ],
};

const Container = styled.div`
  padding: ${props => props.theme.spacing.md};
`;

const InfoEquipo = styled.div`
  background: ${props => props.theme.colors.background};
  padding: ${props => props.theme.spacing.md};
  border-radius: ${props => props.theme.borderRadius.md};
  margin-bottom: ${props => props.theme.spacing.md};
`;

const DetalleEquipo = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${props => props.theme.spacing.sm};
  margin-bottom: ${props => props.theme.spacing.md};
`;

const Campo = styled.div`
  strong {
    color: ${props => props.theme.colors.textSecondary};
  }
`;

/**
 * Lista de Equipos
 * Replica lista_equipos.html
 */
export function ListaEquipos() {
  const navigate = useNavigate();
  const listaRef = useRef();
  const { confirmar } = useConfirm();
  const [filtros, setFiltros] = useState({ sucursal: '', marca: '', modelo: '', estado: '' });
  const [modalAbierto, setModalAbierto] = useState(false);
  const [equipoSeleccionado, setEquipoSeleccionado] = useState(null);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);

  const columnasEquipos = [
    { key: 'codigo_interno', label: 'Código', sortable: true },
    { key: 'marca_nombre', label: 'Marca', sortable: true },
    { key: 'modelo_nombre', label: 'Modelo', sortable: true },
    { key: 'numero_serie', label: 'N° Serie' },
    { key: 'sucursal_nombre', label: 'Sucursal', sortable: true },
    { key: 'estado', label: 'Estado', sortable: true },
    { key: 'horas_acumuladas', label: 'Horas' },
    { key: 'km_acumulados', label: 'Km' }
  ];

  // useEffect debe ir despuÃ©s de las funciones que usa
  // ListaUnificada se encarga de la carga. Cuando cambien filtros, le pedimos refrescar.
  useEffect(() => {
    if (listaRef.current && listaRef.current.refreshImmediate) {
      listaRef.current.refreshImmediate();
    }
  }, [filtros]);

  const abrirModalNuevo = () => {
    setEquipoSeleccionado(null);
    setModoEdicion(false);
    setModalAbierto(true);
  };

  const abrirModalEdicion = (equipo) => {
    setEquipoSeleccionado(equipo);
    setModoEdicion(true);
    setModalAbierto(true);
  };

  const verDetalle = (equipo) => {
    setEquipoSeleccionado(equipo);
    setMostrarDetalle(true);
  };

  // exportaciÃ³n delegada a la vista de administraciÃ³n o toolbar externo

  const guardarEquipo = async (datosFormulario) => {
    try {
      if (modoEdicion) {
        await equiposService.actualizarEquipo(equipoSeleccionado.id, datosFormulario);
      } else {
        await equiposService.crearEquipo(datosFormulario);
      }
      setModalAbierto(false);
  // Forzar refresco de la lista unificada
  if (listaRef.current && listaRef.current.refreshImmediate) listaRef.current.refreshImmediate();
    } catch (error) {
      console.error('Error al guardar equipo:', error);
    }
  };


  // Opciones del toolbar despuÃ©s de las funciones
  // toolbar integrado en ListaUnificada; botones expuestos en props

  const camposFormulario = [
    { key: 'codigo_interno', label: 'CÃ³digo Interno', type: 'text', required: true },
    { key: 'marca', label: 'Marca', type: 'select_api', endpoint: 'marcas', required: true },
    { key: 'modelo', label: 'Modelo', type: 'select_api', endpoint: 'modelos', required: true },
    { key: 'numero_serie', label: 'NÃºmero de Serie', type: 'text' },
    { key: 'sucursal', label: 'Sucursal', type: 'select_api', endpoint: 'sucursales', required: true },
    { key: 'centro_costo', label: 'Centro de Costo', type: 'select_api', endpoint: 'centros-costo' },
    { key: 'tipo_equipo', label: 'Tipo de Equipo', type: 'select_api', endpoint: 'tipos-equipos' },
    { key: 'estado', label: 'Estado', type: 'select', opciones: [
      { value: 'activo', label: 'Activo' },
      { value: 'en_mantenimiento', label: 'En Mantenimiento' },
      { value: 'fuera_de_servicio', label: 'Fuera de Servicio' },
      { value: 'baja', label: 'Baja' }
    ]},
    { key: 'horas_acumuladas', label: 'Horas Acumuladas', type: 'number' },
    { key: 'km_acumulados', label: 'KilÃ³metros Acumulados', type: 'number' },
    { key: 'fecha_compra', label: 'Fecha de Compra', type: 'date' },
    { key: 'observaciones', label: 'Observaciones', type: 'textarea' }
  ];

  return (
      <Container>
        {/* Filtros rÃ¡pidos: mantenemos un control para sucursal pero la lista realiza la carga via endpoint */}
        <FiltroSucursal 
          value={filtros.sucursal}
          onChange={(sucursal) => setFiltros({...filtros, sucursal})}
        />

        <ListaUnificada
          ref={listaRef}
          cloudScope="lista-equipos.state.v1"
          titulo="Equipos"
          icono="bi bi-hdd-network"
          help={HELP}
          endpoint="equipos/"
          columns={columnasEquipos}
          onRowClick={(item) => verDetalle(item)}
          onView={(item) => navigate(`/equipos/${item.id}`)}
          allowView={true}
          filterConfig={[
            { key: 'sucursal', label: 'Sucursal', type: 'text' },
            { key: 'marca', label: 'Marca', type: 'text' },
            { key: 'modelo', label: 'Modelo', type: 'text' },
            { key: 'estado', label: 'Estado', type: 'select', options: [
              { value: 'activo', label: 'Activo' },
              { value: 'en_mantenimiento', label: 'En mantenimiento' },
              { value: 'fuera_de_servicio', label: 'Fuera de servicio' },
              { value: 'baja', label: 'Baja' }
            ]}
          ]}
          onAdd={abrirModalNuevo}
          onEdit={(item) => abrirModalEdicion(item)}
          onDelete={async (item, index, performDelete) => {
            const ok = await confirmar({
              titulo: `¿Eliminar equipo ${item && (item.codigo_interno || item.id)}?`,
              labelConfirmar: 'Sí, eliminar',
              variante: 'danger',
            });
            if (!ok) return false;
            return performDelete();
          }}
          allowAdd={true}
          allowEdit={true}
          allowDelete={true}
        />

        {modalAbierto && (
          <Modal 
            title={modoEdicion ? 'Editar Equipo' : 'Nuevo Equipo'}
            onClose={() => setModalAbierto(false)}
          >
            <FormularioBase
              campos={camposFormulario}
              datosIniciales={equipoSeleccionado}
              onSubmit={guardarEquipo}
              onCancelar={() => setModalAbierto(false)}
              showTitle={false}
              compact={true}
            />
          </Modal>
        )}

        {mostrarDetalle && equipoSeleccionado && (
          <Modal 
            titulo={`Detalle de Equipo - ${equipoSeleccionado.codigo_interno}`}
            onCerrar={() => setMostrarDetalle(false)}
          >
            <InfoEquipo>
              <DetalleEquipo>
                <Campo><strong>CÃ³digo:</strong> {equipoSeleccionado.codigo_interno}</Campo>
                <Campo><strong>Marca:</strong> {equipoSeleccionado.marca_nombre}</Campo>
                <Campo><strong>Modelo:</strong> {equipoSeleccionado.modelo_nombre}</Campo>
                <Campo><strong>NÂ° Serie:</strong> {equipoSeleccionado.numero_serie}</Campo>
                <Campo><strong>Sucursal:</strong> {equipoSeleccionado.sucursal_nombre}</Campo>
                <Campo><strong>Estado:</strong> {equipoSeleccionado.estado}</Campo>
                <Campo><strong>Horas:</strong> {equipoSeleccionado.horas_acumuladas}</Campo>
                <Campo><strong>KilÃ³metros:</strong> {equipoSeleccionado.km_acumulados}</Campo>
                <Campo><strong>Fecha Compra:</strong> {equipoSeleccionado.fecha_compra}</Campo>
              </DetalleEquipo>
              {equipoSeleccionado.observaciones && (
                <Campo>
                  <strong>Observaciones:</strong><br />
                  {equipoSeleccionado.observaciones}
                </Campo>
              )}
              <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                <button onClick={() => navigate(`/equipos/${equipoSeleccionado.id}`)}>
                  Ver perfil completo y configuraciÃ³n de mantenimiento
                </button>
              </div>
            </InfoEquipo>
          </Modal>
        )}
  </Container>
  );
}

export default ListaEquipos;
